import { render } from "./base-startup-revenues-chart.vue?vue&type=template&id=8f32e59a"
import script from "./base-startup-revenues-chart.vue?vue&type=script&lang=js"
export * from "./base-startup-revenues-chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__